import React from "react";

// import woman image
// import WomanImg from '../assets/img/banner-woman2.webp';


import banner from "../../../../assets/img/static/Human Robotic Brain.png";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section
      id="home"
      className="lg:h-[85vh] flex  items-center bg-primary lg:bg-cover lg:bg-center lg:bg-no-repeat pb-64 pt-8 lg:py-0 overflow-hidden"
    >
      <div className="container mx-auto h-full">
        <div className="flex items-center h-full pt-8">
          <div className="flex-1 flex flex-col items-center lg:items-start">
            <p className="text-lg text-accent text-md mb-[22px]">
              Hey, there! 👋
            </p>
            <h1 className="text-2xl leading-[44px] md:text-5xl md:leading-tight lg:text-7xl lg:leading-[1.2] font-bold md:tracking-[-2px]">
              {/* we design & build <br /> modern websites */}
              Your Vision <br /> Our Expertise
            </h1>
            <p className="pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left">
              {/* we design and build mobile and web apps from concept to final
              product with in a given time and best quality */}
              Tech X Neuro – where ideas turn into reality.
              <br /> We specialize in custom software development, AI solutions,
              digital marketing, and creative services, empowering businesses
              worldwide with next-generation technology.
            </p>

            {/* <button className="btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all rounded-xl">
              Work with us
            </button> */}
            {/* <button
              className="btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg 
                    transition-all duration-300 ease-in-out rounded-xl 
                    hover:scale-105"
            >
              Work with us
            </button> */}

            <Link
              to="/#contact"
              activeClass="active"
              spy={true}
              smooth={true}
              duration={500}
              offset={-70}
              className="btn btn-md bg-accent hover:bg-secondary-hover transition-all rounded-xl"
            >
              Work with us
            </Link>
          </div>
          <div className="hidden lg:flex flex-1 justify-end items-center h-full">
            {/* <img src={WomanImg} alt='' /> */}
            <img src={banner} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
